import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconFlag.tsx
const OutlinedFilledFlag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M175-95v-731h389l19.33 86H826v421H523l-19-85H269v309h-94Z" })
});
const OutlinedFlag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M175-95v-731h389l19.33 86H826v421H523l-18.93-85H269v309h-94Zm325-477Zm103 159h128v-232H502.93L484-731H269v233h315.05L603-413Z" })
});
const RoundedFilledFlag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M269-404v262q0 19.75-13.68 33.37Q241.65-95 221.82-95 202-95 188.5-108.63 175-122.25 175-142v-636q0-19.75 13.63-33.88Q202.25-826 222-826h304q16.5 0 29.75 11.5T572-787l11 47h195q19.75 0 33.88 14.12Q826-711.75 826-692v326q0 19.75-14.12 33.37Q797.75-319 778-319H561q-16.5 0-29.75-10.5T515-356l-11-48H269Z" })
});
const RoundedFlag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M269-404v262q0 19.75-13.68 33.37Q241.65-95 221.82-95 202-95 188.5-108.63 175-122.25 175-142v-636q0-19.75 13.63-33.88Q202.25-826 222-826h304q16.5 0 29.75 11.5T572-787l11 47h195q19.75 0 33.88 14.12Q826-711.75 826-692v326q0 19.75-14.12 33.37Q797.75-319 778-319H561q-16.5 0-29.75-10.5T515-356l-11-48H269Zm334-9h128v-232H541q-16.5 0-29.75-11T495-683l-11-48H269v233h277q16.5 0 29.75 10.5T592-461l11 48ZM500-572Z" })
});
const SharpFilledFlag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M175-95v-731h389l19.33 86H826v421H523l-19-85H269v309h-94Z" })
});
const SharpFlag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M175-95v-731h389l19.33 86H826v421H523l-18.93-85H269v309h-94Zm325-477Zm103 159h128v-232H502.93L484-731H269v233h315.05L603-413Z" })
});
const componentMap = {
	outlined: OutlinedFlag,
	"outlined-fill": OutlinedFilledFlag,
	rounded: RoundedFlag,
	"rounded-fill": RoundedFilledFlag,
	sharp: SharpFlag,
	"sharp-fill": SharpFilledFlag
};
const IconFlag = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconFlag };